<div class="time-picker-container">
  <!-- Hour Picker -->
  <div class="time-segment">
    <button class="arrow-btn" (click)="incrementHour()" aria-label="Increment hour"><i class="fas fa-chevron-up"></i></button>
    <input
      type="text"
      class="time-input"
      [value]="hour | number: '2.0'"
      (change)="onHourChange($event)"
      maxlength="2"
      aria-label="Hour"
    />
    <button class="arrow-btn" (click)="decrementHour()" aria-label="Decrement hour"><i class="fas fa-chevron-down"></i></button>
  </div>

  <span class="separator">:</span>

  <!-- Minute Picker -->
  <div class="time-segment">
    <button class="arrow-btn" (click)="incrementMinute()" aria-label="Increment minute"><i class="fas fa-chevron-up"></i></button>
    <input
      type="text"
      class="time-input"
      [value]="minute | number: '2.0'"
      (change)="onMinuteChange($event)"
      maxlength="2"
      aria-label="Minute"
    />
    <button class="arrow-btn" (click)="decrementMinute()" aria-label="Decrement minute"><i class="fas fa-chevron-down"></i></button>
  </div>

  @if (showPeriod) {
    <div class="period-segment">
      <button class="period-btn" (click)="togglePeriod()">{{ period }}</button>
    </div>
  }
</div>
